import { heroFacts, heroTags } from "@/mocks/home";

export default function Hero() {
  return (
    <section id="top" className="relative w-full overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Grand%20stylized%20illustration%20of%20a%20traditional%20Chinese%20mansion%20courtyard%20at%20dusk%20with%20glowing%20lanterns%20and%20lattice%20windows%2C%20rich%20coral%20rose%20gold%20and%20deep%20brown%20tones%2C%20decorative%20cinematic%20poster%20art%20style%2C%20soft%20atmospheric%20haze%2C%20no%20text%2C%20elegant%20refined%20composition&width=1920&height=1080&seq=flnv-hero-001&orientation=landscape"
          alt="风流女管家主题大图"
          className="h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/45 to-black/70"></div>
      </div>

      <div className="relative mx-auto flex min-h-[640px] w-full max-w-6xl flex-col justify-center px-4 pb-16 pt-28 md:min-h-[720px] md:px-8 md:pt-32">
        <div className="w-full animate-float-up">
          <span className="inline-flex items-center gap-2 rounded-full border border-background-50/40 bg-background-50/10 px-3 py-1 font-label text-xs tracking-wide text-background-100 backdrop-blur">
            <i className="ri-movie-2-line text-sm"></i>
            剧集 · 小说 · 漫画 一站式入口导航
          </span>

          <h1 className="font-heading mt-5 text-4xl font-black leading-tight text-background-50 md:text-6xl">
            风流女管家
            <span className="mt-3 block font-heading text-lg font-medium text-background-100 md:text-2xl">
              全集在线观看 · 无删减版 · 小说原著 · 漫画全收录
            </span>
          </h1>

          <p className="mt-5 max-w-2xl text-sm leading-relaxed text-background-200 md:text-base">
            想追剧、想补番、想先看原著，还是想对着漫画追进度？本页把分散的入口集中到一起，按你想要的版本一步步找到对应内容，不用再到处翻搜索结果。
          </p>

          <div className="mt-7 flex flex-col gap-3 sm:flex-row sm:items-center">
            <a
              href="#access"
              className="inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 font-label text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 dark:text-foreground-950"
            >
              <i className="ri-compass-3-line text-lg"></i>
              马上找观看入口
            </a>
            <a
              href="#uncut"
              className="inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/50 px-6 py-3 font-label text-sm font-medium text-background-50 transition-colors hover:bg-background-50/15"
            >
              <i className="ri-checkbox-multiple-line text-lg"></i>
              先看无删减说明
            </a>
          </div>

          <ul className="mt-6 flex flex-wrap gap-2">
            {heroTags.map((tag) => (
              <li
                key={tag}
                className="rounded-full border border-background-50/25 bg-background-50/10 px-3 py-1 font-label text-xs text-background-100 backdrop-blur"
              >
                {tag}
              </li>
            ))}
          </ul>

          <dl className="mt-10 grid w-full grid-cols-2 gap-3 md:grid-cols-4 md:gap-4">
            {heroFacts.map((fact) => (
              <div
                key={fact.label}
                className="rounded-lg border border-background-50/20 bg-background-50/10 p-4 backdrop-blur"
              >
                <dt className="font-label text-xs text-background-300">{fact.label}</dt>
                <dd className="mt-1 font-heading text-sm font-semibold text-background-50 md:text-base">
                  {fact.value}
                </dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </section>
  );
}